import React, {useContext, useEffect} from 'react';
import UseUser, {UserCategory, UserGender, UserGrade} from '../../hooks/apis/useUser';
import UserRegisterForm, {IUserRegisterForm} from '../../components/user/RegisterForm';
import {Alert, Breadcrumb, Button, Card, Descriptions, message, Result} from 'antd';
import useAuth from '../../utils/AuthContext';
import QuickRouter from '../../utils/QuickRouter';
import useUser from '../../hooks/apis/useUser';
import moment from 'moment';
import UserDetail from '../../components/user/Detail';
import {useBoolean} from 'react-hanger';
import UserProfileForm, {IUserProfileForm} from '../../components/user/ProfileForm';
import Flex from '../../components/Flex';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import CustomerError from '../../components/CustomerError';
import useQuickRouter from '../../utils/QuickRouter';

export default function UserProfilePage() {
  const auth = useAuth();
  const queryByIdState = useUser.queryById();
  const updateProfileState = useUser.updateProfile();
  const user = queryByIdState.data;
  const editMode = useBoolean(false);
  const quickRouter = useQuickRouter();

  function refresh() {
    if (auth.currentUser) {
      queryByIdState.request({id: auth.currentUser.id}).catch(CommonApiErrorHandler);
    }
  }

  function updateProfile(form: IUserProfileForm) {
    updateProfileState
      .request(form)
      .then(() => {
        message.success('操作成功');
        editMode.setFalse();
        refresh();
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, [auth.currentUser]);

  if (!auth.currentUser) return <CustomerError title={'请登录后操作'} />;

  return (
    <div>
      <Card
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <a onClick={quickRouter.index}>首页</a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>个人信息</Breadcrumb.Item>
          </Breadcrumb>
        }
        loading={queryByIdState.loading}>
        {user && (
          <React.Fragment>
            {user.legalName && !editMode.value && (
              <Flex direction={'column'} align={'center'}>
                <UserDetail user={user} />
                <Button style={{margin: '10px auto'}} onClick={editMode.setTrue}>
                  修改信息
                </Button>
              </Flex>
            )}
            {!user.legalName && !editMode.value && (
              <Result title={'你还未补充个人信息'} status={'warning'} extra={<Button onClick={editMode.setTrue}>立即填写</Button>} />
            )}
            {editMode.value && (
              <UserProfileForm
                onCancel={editMode.setFalse}
                form={{...user, birthDate: moment(user.birthDate)}}
                isLoading={updateProfileState.loading}
                onFinish={updateProfile}
              />
            )}
          </React.Fragment>
        )}
      </Card>
      {/*<UserRegisterForm isLoading={registerState.loading} onFinish={register} />*/}
    </div>
  );
}
